var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white",
    stroke: "#8C4D3F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9755_237611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1558 13.0233L24.7584 11.832C24.607 11.3783 24.1839 11.0734 23.7057 11.0734H20.3655V9.98589C20.3655 9.44234 19.9235 9 19.3801 9H16.3213C15.778 9 15.3359 9.44234 15.3359 9.98589V11.0734H11.9958C11.5175 11.0734 11.0944 11.3783 10.943 11.832L10.5456 13.0233C10.4551 13.2946 10.501 13.5949 10.6681 13.8268C10.8352 14.0588 11.1056 14.1974 11.3916 14.1974H11.807L12.7213 25.5038C12.7893 26.3427 13.5012 27 14.3424 27H21.5446C22.3856 27 23.0976 26.3427 23.1655 25.5037L24.0798 14.1974H24.3098C24.5958 14.1974 24.8662 14.0588 25.0333 13.827C25.2004 13.595 25.2463 13.2946 25.1558 13.0233ZM16.3906 10.0547H19.3108V11.0734H16.3906V10.0547ZM22.1142 25.4187C22.0903 25.7141 21.8401 25.9453 21.5446 25.9453H14.3424C14.0468 25.9453 13.7966 25.7141 13.7727 25.4187L12.8651 14.1974H23.0217L22.1142 25.4187ZM11.6177 13.1427L11.9436 12.1657C11.951 12.1432 11.972 12.1281 11.9958 12.1281H23.7057C23.7295 12.1281 23.7504 12.1432 23.7579 12.1657L24.0838 13.1427H11.6177Z",
    fill: "#8C4D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 25.3813C20.4409 25.3819 20.4501 25.382 20.4594 25.382C20.7381 25.382 20.971 25.1636 20.9855 24.8821L21.4808 15.3759C21.4959 15.0851 21.2723 14.8369 20.9816 14.8218C20.69 14.8063 20.4427 15.0301 20.4274 15.321L19.9324 24.8272C19.9173 25.1181 20.1407 25.3662 20.4316 25.3813Z",
    fill: "#8C4D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7381 24.8834C14.7535 25.1645 14.9861 25.382 15.2642 25.382C15.2738 25.382 15.2837 25.3817 15.2934 25.3812C15.5842 25.3654 15.8071 25.1168 15.7913 24.826L15.2726 15.3198C15.2568 15.0289 15.0082 14.806 14.7174 14.8219C14.4266 14.8377 14.2037 15.0863 14.2195 15.3772L14.7381 24.8834Z",
    fill: "#8C4D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8574 25.382C18.1487 25.382 18.3848 25.1459 18.3848 24.8546V15.3484C18.3848 15.0572 18.1487 14.8211 17.8574 14.8211C17.5661 14.8211 17.3301 15.0572 17.3301 15.3484V24.8546C17.3301 25.1459 17.5661 25.382 17.8574 25.382Z",
    fill: "#8C4D3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9755_237611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNew);
export default __webpack_public_path__ + "static/media/deleteNew.bfc5f577.svg";
export { ForwardRef as ReactComponent };